"use client";
import { resolveClassNames } from "../resolve-class-names/resolve-class-names.mjs";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-resolved-class-names/get-resolved-class-names.ts
function getResolvedClassNames({ selector, stylesCtx, theme, classNames, props }) {
	return resolveClassNames({
		theme,
		classNames,
		props,
		stylesCtx
	})[selector];
}
//#endregion
export { getResolvedClassNames };

//# sourceMappingURL=get-resolved-class-names.mjs.map